export default "__VITE_ASSET__BSiwygG4__"